export const COLUMN_TOOLTIPS = {
  keyword: "The search term being tracked for this ASIN",
  searchVolume: "Estimated monthly search volume on Amazon",
  organicRank: "Current organic search ranking position",
  change: "Rank change vs. previous period",
  dateAdded: "When this keyword was added to tracking",
} as const;
